module.exports = __webpack_public_path__ + "img/asset_result_center.6a2702e7.png";